import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  SectionsEdit,
  SectionsOrderPage,
  SectionsPage,
  YellowBooksEdit,
  YellowBooksPage,
} from '../pages/CMSPages/index';
import React from 'react';

const YellowBooksRoutes = () => (
  <>
    <Route
      path={routes.cmsYellowBooks}
      element={
        <CMSWrapper permissions={['yellow-books.index']}>
          <YellowBooksPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsYellowBooksCreate}
      element={
        <CMSWrapper permissions={['yellow-books.store']}>
          <YellowBooksEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsYellowBooksEdit}/:id`}
      element={
        <CMSWrapper permissions={['yellow-books.show']}>
          <YellowBooksEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsYellowBooksSections(':yellowBookId')}
      element={
        <CMSWrapper permissions={['yellow-books.show']}>
          <SectionsPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsYellowBookSectionsCreate(':yellowBookId')}
      element={
        <CMSWrapper permissions={['yellow-books.store']}>
          <SectionsEdit mode="create" />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsYellowBookSectionsEdit(':yellowBookId', ':sectionId')}
      element={
        <CMSWrapper permissions={['yellow-books.store']}>
          <SectionsEdit mode="edit" />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsYellowBookSectionsChild(':yellowBookId', ':sectionId')}
      element={
        <CMSWrapper permissions={['yellow-books.store']}>
          <SectionsEdit mode="child" />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsYellowBookSectionsCopy(':yellowBookId', ':sectionId')}
      element={
        <CMSWrapper permissions={['yellow-books.store']}>
          <SectionsEdit mode="copy" />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsYellowBookSectionsOrder(':yellowBookId')}
      element={
        <CMSWrapper permissions={['yellow-books.store']}>
          <SectionsOrderPage />
        </CMSWrapper>
      }
    />
  </>
);

export default YellowBooksRoutes;
